import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Check, X, Trash2 } from "lucide-react";

const STATUS_LABEL = { pending: "En attente", approved: "Validé", rejected: "Refusé" };
const STATUS_CLS = {
  pending: "bg-[#F4A261]/20 text-[#E76F51]",
  approved: "bg-[#2D6A4F]/15 text-[#2D6A4F]",
  rejected: "bg-[#D62828]/15 text-[#D62828]",
};

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/users");
      setUsers(data);
    } catch { toast.error("Erreur"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/admin/users/${id}/status`, { status });
      toast.success("Statut mis à jour");
      load();
    } catch { toast.error("Erreur"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Supprimer ce client ?")) return;
    try {
      await api.delete(`/admin/users/${id}`);
      toast.success("Client supprimé");
      load();
    } catch { toast.error("Erreur"); }
  };

  const customers = users.filter((u) => u.role === "customer");
  const pending = customers.filter((u) => u.status === "pending");

  return (
    <div data-testid="admin-users-page">
      <p className="ff-overline">Comptes clients</p>
      <h1 className="font-serif text-3xl mt-2">Clients pro ({customers.length})</h1>
      {pending.length > 0 && (
        <p className="mt-2 text-sm text-[#E76F51]" data-testid="admin-pending-count">
          {pending.length} compte(s) en attente de validation
        </p>
      )}

      {loading ? (
        <p className="mt-8 text-[#8A9A8E]">Chargement...</p>
      ) : (
        <div className="mt-8 bg-white border border-[#E5E3DC] overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#F2EFEB] text-left">
              <tr>
                <th className="p-3">Entreprise</th>
                <th className="p-3">Contact</th>
                <th className="p-3">Email</th>
                <th className="p-3">Téléphone</th>
                <th className="p-3">Statut</th>
                <th className="p-3 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((u) => (
                <tr key={u.id} className="border-t border-[#F2EFEB]" data-testid={`admin-user-row-${u.id}`}>
                  <td className="p-3">
                    <div className="font-medium">{u.company_name}</div>
                    <div className="text-xs text-[#8A9A8E]">N° {u.company_number}</div>
                  </td>
                  <td className="p-3">{u.first_name} {u.last_name}</td>
                  <td className="p-3 text-[#4A5D4E]">{u.email}</td>
                  <td className="p-3 text-[#4A5D4E]">{u.phone}</td>
                  <td className="p-3"><span className={`px-2 py-1 text-xs ${STATUS_CLS[u.status]}`}>{STATUS_LABEL[u.status]}</span></td>
                  <td className="p-3 text-right">
                    <div className="inline-flex gap-1">
                      {u.status !== "approved" && (
                        <button onClick={() => setStatus(u.id, "approved")} className="p-2 hover:bg-[#F2EFEB] text-[#2D6A4F]" title="Valider" data-testid={`admin-approve-user-${u.id}`}>
                          <Check className="w-4 h-4" />
                        </button>
                      )}
                      {u.status !== "rejected" && (
                        <button onClick={() => setStatus(u.id, "rejected")} className="p-2 hover:bg-[#F2EFEB] text-[#D62828]" title="Refuser" data-testid={`admin-reject-user-${u.id}`}>
                          <X className="w-4 h-4" />
                        </button>
                      )}
                      <button onClick={() => remove(u.id)} className="p-2 hover:bg-[#F2EFEB] text-[#D62828]" title="Supprimer" data-testid={`admin-delete-user-${u.id}`}>
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
